<template>
    <TariffNotificationModal
        ref="modal"
        title="Попробуйте все возможности бесплатно"
        button-text="Узнать подробнее"
        image-url="/assets/images/tariff/try_all_features.png"
        @hidden="emit('hidden')"
        @button-click="emit('confirm')"
    >
        <p class="mb-2 pb-1">
            Вам доступен полный функционал платформы бесплатно в течение 7 дней. 
        </p>
        <p>
            После — можно подключить только нужные вам функции. Узнайте подробнее и выберите подходящий вариант.
        </p>
    </TariffNotificationModal>
</template>

<script lang="ts" setup>
const modal = ref<InstanceType<typeof TariffNotificationModal>>();
import TariffNotificationModal from '@/components/TariffNotificationModal.vue';
import { ref } from 'vue';

defineExpose({
    show() {
        modal.value?.show();
    },
});

const emit = defineEmits<{
    (e: 'hidden'): void;
    (e: 'confirm'): void;
}>();

</script>